import { render } from "./ProblemSearchModal.vue?vue&type=template&id=1e85301d&scoped=true&ts=true"
import script from "./ProblemSearchModal.vue?vue&type=script&lang=ts"
export * from "./ProblemSearchModal.vue?vue&type=script&lang=ts"

import "./ProblemSearchModal.vue?vue&type=style&index=0&id=1e85301d&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e85301d"]])

export default __exports__